import { render, staticRenderFns } from "./ContactMortgage.vue?vue&type=template&id=74082ca0"
import script from "./ContactMortgage.vue?vue&type=script&lang=js"
export * from "./ContactMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports